// The pictures a template can wear: those of each experience of the trip,
// taken once, on the first day of the experience.
export function getTemplateImages(
  days: any[],
  experiences: Record<string, any>,
): string[] {
  const images: string[] = [];
  const add = (imageUrl?: string) => {
    if (imageUrl && !images.includes(imageUrl)) {
      images.push(imageUrl);
    }
  };

  days?.forEach((day) => {
    const experience = day?.experienceId
      ? experiences?.[day.experienceId]
      : null;

    // `experienceDayIndex` is 1-based.
    if (!experience || day.experienceDayIndex > 1) {
      return;
    }

    add(experience.imageUrl);
    experience.pictures?.forEach((picture: any) => add(picture.imageUrl));
  });

  return images;
}
